/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdgangAccessControl } from './AdgangAccessControl';
import {
    AdgangAccessControlFromJSON,
    AdgangAccessControlFromJSONTyped,
    AdgangAccessControlToJSON,
    AdgangAccessControlToJSONTyped,
} from './AdgangAccessControl';

/**
 * 
 * @export
 * @interface RoleConsumptionResponse
 */
export interface RoleConsumptionResponse {
    /**
     * 
     * @type {any}
     * @memberof RoleConsumptionResponse
     */
    roleId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleConsumptionResponse
     */
    isConsumedByOtherEntitities?: boolean;
    /**
     * 
     * @type {any}
     * @memberof RoleConsumptionResponse
     */
    numUserRoles?: any | null;
    /**
     * 
     * @type {any}
     * @memberof RoleConsumptionResponse
     */
    numAdGroupRoles?: any | null;
    /**
     * 
     * @type {any}
     * @memberof RoleConsumptionResponse
     */
    numSectionRoles?: any | null;
    /**
     * 
     * @type {any}
     * @memberof RoleConsumptionResponse
     */
    numActiveAccessRequests?: any | null;
    /**
     * 
     * @type {Array<AdgangAccessControl>}
     * @memberof RoleConsumptionResponse
     */
    accessControls?: Array<AdgangAccessControl> | null;
}

/**
 * Check if a given object implements the RoleConsumptionResponse interface.
 */
export function instanceOfRoleConsumptionResponse(value: object): value is RoleConsumptionResponse {
    return true;
}

export function RoleConsumptionResponseFromJSON(json: any): RoleConsumptionResponse {
    return RoleConsumptionResponseFromJSONTyped(json, false);
}

export function RoleConsumptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleConsumptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'isConsumedByOtherEntitities': json['isConsumedByOtherEntitities'] == null ? undefined : json['isConsumedByOtherEntitities'],
        'numUserRoles': json['numUserRoles'] === undefined ? undefined : json['numUserRoles'] === null ? null : json['numUserRoles'],
        'numAdGroupRoles': json['numAdGroupRoles'] === undefined ? undefined : json['numAdGroupRoles'] === null ? null : json['numAdGroupRoles'],
        'numSectionRoles': json['numSectionRoles'] === undefined ? undefined : json['numSectionRoles'] === null ? null : json['numSectionRoles'],
        'numActiveAccessRequests': json['numActiveAccessRequests'] === undefined ? undefined : json['numActiveAccessRequests'] === null ? null : json['numActiveAccessRequests'],
        'accessControls': json['accessControls'] === undefined ? undefined : json['accessControls'] === null ? null : ((json['accessControls'] as Array<any>).map(AdgangAccessControlFromJSON)),
    };
}

export function RoleConsumptionResponseToJSON(json: any): RoleConsumptionResponse {
    return RoleConsumptionResponseToJSONTyped(json, false);
}

export function RoleConsumptionResponseToJSONTyped(value?: RoleConsumptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'isConsumedByOtherEntitities': value['isConsumedByOtherEntitities'],
        'numUserRoles': value['numUserRoles'],
        'numAdGroupRoles': value['numAdGroupRoles'],
        'numSectionRoles': value['numSectionRoles'],
        'numActiveAccessRequests': value['numActiveAccessRequests'],
        'accessControls': value['accessControls'] == null ? undefined : ((value['accessControls'] as Array<any>).map(AdgangAccessControlToJSON)),
    };
}

